<template >
  <el-input
    maxlength="6"
    :value="value"
    :placeholder="$t('commons.input_placeholder')"
    @input="$emit('input',$event)"
  >
    <span slot="append" @click="sendMsg" class="pointer">
      <template v-if="status === 0">{{$t('components.public.manyboVerifyCode.sendMsg')}}</template>
      <template v-if="status === 1">{{$t('components.public.manyboVerifyCode.sendingMsg')}}</template>
      <template
        v-if="status === 2"
      >{{$t('components.public.manyboVerifyCode.sentMsg')}} {{ seconds }}</template>
    </span>
  </el-input>
</template>
<script>
const countdown_s = 60
export default {
  props: {
    phone: {
      type: [String, Number],
      require: true,
    },
    value: {
      type: [String, Number],
      require: true,
    },
  },
  watch: {
    phone(nV, oV) {
      if (this._timer_id) {
        clearInterval(this._timer_id)
        this.setData({
          status: 0,
          seconds: 0,
          _timer_id: null,
        })
      }
    },
  },
  data() {
    return {
      seconds: 0,
      status: 0,
    }
  },
  methods: {
    sendMsg() {
      const { status, seconds, phone } = this
      // 等于0 才可以发
      if (status === 0) {
        this.status = 1
        if (this._timer_id) {
          clearInterval(this._timer_id)
          this._timer_id = null
        }

        this.$axios
          .post('/Phone/sendVerifySMS', {
            phone,
          })
          .then(() => {
            this.setData({
              status: 2,
              seconds: countdown_s,
            })
            this._timer_id = setInterval(() => {
              this.seconds--
              if (!this.seconds) {
                clearInterval(this._timer_id)
                this.setData({
                  status: 0,
                  seconds: 0,
                  _timer_id: null,
                })
              }
            }, 1000)
          })
      }
    },
  },
}
</script>
<style lang='scss' scoped>
</style>
